<template>
    <!-- Actividad del equipo: quién movió, anotó o cambió cada tarjeta (GET actividad). -->
    <CrmModal :titulo="crm.t('activity.t')" :sub="crm.t('activity.sub')" :mw="640" @cerrar="$emit('cerrar')">
        <div class="cr-tl-filter">
            <button type="button" class="cr-chip" :aria-pressed="String(!quien)" @click="elegir('')">{{ crm.t('activity.all') }}</button>
            <button v-for="b in crm.brokers.filter(x => x.acceso)" :key="b.id" type="button" class="cr-chip" :aria-pressed="String(quien === b.id)" @click="elegir(b.id)">
                <span v-html="crm.avHTML(b.id, 'cr-av--s')"></span>{{ b.nombre }}<span class="cr-n">{{ conteo[b.id] || 0 }}</span>
            </button>
        </div>
        <div v-if="cargando && !items" class="cr-tl-empty">{{ crm.t('loading') }}</div>
        <p v-else-if="error" class="cr-note cr-note--bad"><span v-html="I.warn"></span><span>{{ crm.t('error.p') }}</span></p>
        <CrmTimeline v-else :items="items || []" con-tarjeta :vacio="crm.t('activity.empty')" @abrir="abrir" />
    </CrmModal>
</template>

<script>
import axios from 'axios';
import CrmModal from './CrmModal.vue';
import CrmTimeline from './CrmTimeline.vue';
import { I } from './crmUtil';

export default {
    name: 'CrmActividad',
    components: { CrmModal, CrmTimeline },
    inject: ['crm'],
    props: { quienInicial: { type: [Number, String], default: '' } },
    data() { return { I, quien: this.quienInicial || '', items: null, conteo: {}, cargando: false, error: false }; },
    created() { this.cargar(); },
    methods: {
        async cargar() {
            const req = (this._req = (this._req || 0) + 1);
            this.cargando = true; this.error = false;
            try {
                const { data } = await axios.get(`${process.env.VUE_APP_API_URL}admin/crm-anfitriones/actividad`, { params: this.quien ? { usuario: this.quien } : {} });
                if (req !== this._req) return;
                this.items = data.items || [];
                this.conteo = data.conteo || {};
            } catch (e) { if (req === this._req) this.error = true; }
            if (req === this._req) this.cargando = false;
        },
        elegir(q) { this.quien = q; this.cargar(); },
        abrir(id) { if (!this.crm.tarjeta(id)) return; this.$emit('cerrar'); this.crm.abrir(id, 'historial'); },
    },
};
</script>
